import EEStudentDashboardPageStyle from '../../../../components/EEStudentDashboardPageStyle';

export default [EEStudentDashboardPageStyle];
